<template>
  <div>
    <el-row :gutter="10">
      <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="item in newsList" :key="item.pk">
        <router-link :to="'/newscont/' + item.pk + '/'" tag="a">
          <el-card shadow="hover">
            <el-row :gutter="15">
              <el-col :xs="24" :sm="8" :md="8">
                <div class="news_thumb" style="height: 130px; overflow: hidden;">
                  <img :src="$domainPrefix + item.thumb" style=" width:100%; " />
                </div>
              </el-col>
              <el-col :xs="24" :sm="16" :md="16">
                <div class="news-title">
                  <el-tag class="margin-left" effect="dark" type="danger" size="mini">
                    <i class="el-icon-s-promotion"></i>
                    {{ item.column__name }}
                  </el-tag>
                  {{ item.title }}
                </div>
                <div>
                  <el-tag class="margin-left" effect="light" type="info" size="mini">
                    <i class="el-icon-date"></i>
                    {{ item.create_date }}
                  </el-tag>
                  <el-tag class="margin-left" effect="light" type="success" size="mini">
                    <i class="el-icon-view"></i>
                    {{ item.reads }}
                  </el-tag>
                  <el-tag class="margin-left" effect="light" type="warning" size="mini">
                    <i class="el-icon-thumb"></i>
                    {{ item.thumbup }}
                  </el-tag>
                </div>
                <div class="news-abstract">{{ item.abstract.substring(0,50) }}...</div>
              </el-col>
            </el-row>
          </el-card>
        </router-link>
      </el-col>
    </el-row>
    <el-row style="margin:20px 0; text-align: center;"><el-pagination background layout="prev, pager, next" :total="1"></el-pagination></el-row>
  </div>
</template>

<script>
export default {
    data () {
        return {
            newsList: []
        }
    },
    created () {
        var that = this
        var currentPath = that.$route.fullPath
        this.$store.dispatch('setMainNav', currentPath)
        this.$axios
            .get('/api/getnewslist/')
            .then(function (response) {
                that.newsList = response.data
            })
            .catch(function (error) {
                console.log(error)
            })
    }
}
</script>

<style scoped>
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: auto;
}

.el-col {
  margin: 5px 0;
}
.news-title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
  display: block;
}

.news-abstract {
  font-size: 14px;
  color: #606266;
  margin-bottom: 5px;
  margin-top: 10px;
  display: block;
}

.margin-left {
  margin-right: 2px;
}

.news_thumb :hover {
animation: movein 1s linear forwards;
}
@keyframes movein {
    0% {transform: scale(1,1);}
    30% {transform: scale(2,1);}
    60% {transform: scale(1,2);}
    100% {-webkit-transform: scale(1,1);}
}
</style>
